import { TextLink, Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import type { ComplianceDetails, ProfileData } from "libs/codegen/property-onboarding";
import { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { ComplianceDetailsFields } from "./ComplianceDetailsFields";

export const UltimateOwnerController = () => {
    const {
        cmsData: {
            profile: {
                ultimateBeneficialOwner,
                ultimateBeneficialOwnerDescription,
                owner,
                addMoreOwner,
                removeOwner,
                removeOwnerConfirmation,
            },
        },
    } = useStaticDataAtomValue();
    const { control } = useFormContext<ProfileData>();
    const { fields, append, remove } = useFieldArray({
        control,
        name: "ultimateOwners",
    });

    useEffect(() => {
        if (fields.length <= 0) append({} as ComplianceDetails);
    }, [fields]);

    return (
        <VStack gap="24">
            <VStack gap="8">
                <Typography variant="heading-default">{ultimateBeneficialOwner}</Typography>
                <Typography variant="body-s" textColor="base.subtle">
                    {ultimateBeneficialOwnerDescription}
                </Typography>
            </VStack>
            {fields.map((field, index) => (
                <ComplianceDetailsFields
                    key={field.id}
                    fieldPrefix={`ultimateOwners.${index}`}
                    index={index}
                    multiplePrefix={owner}
                    multiple={fields.length > 1}
                    onRemove={() => remove(index)}
                    disableStateCityFields
                    removeModalTitle={removeOwner}
                    removeModalDescription={removeOwnerConfirmation}
                    prefixDataElementName="owner"
                    secondPrefixDataElementName="owner"
                />
            ))}
            <TextLink
                label={addMoreOwner}
                onClick={() => append({} as ComplianceDetails)}
                data-element-name="add-owner"
            />
        </VStack>
    );
};
